import { render, staticRenderFns } from "./expertConsultation.vue?vue&type=template&id=c38a602a&scoped=true&"
import script from "./expertConsultation.vue?vue&type=script&lang=js&"
export * from "./expertConsultation.vue?vue&type=script&lang=js&"
import style0 from "./expertConsultation.vue?vue&type=style&index=0&id=c38a602a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38a602a",
  null
  
)

export default component.exports